import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import "./Modal.css";
import { SiTicktick } from "react-icons/si";
import { IoChevronForward, IoClose } from "react-icons/io5";
import { Store } from "../../context/StoreContext";

const TransactionSucessModal = ({
  showTransactionSucess,
  setShowTransactionSucess,
}) => {
  const { transactionHash, setTransactionHash } = useContext(Store)
  return (
    <Modal
      show={showTransactionSucess}
      onHide={() => setShowTransactionSucess(false)}
      centered
      size="lg"
      className="transactionSUcess"
    // backdrop="static"
    // keyboard={false}
    >
      <Modal.Header className="custom-header">
        <div
          className="custom-close"
          onClick={() => setShowTransactionSucess(false)}
        >
          <IoClose size={24} color="#fff" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="img-box">
          <SiTicktick color="#28a745" />
        </div>
        <div className="conetnt">
          <h1>Transaction Success</h1>
          <a
            href={transactionHash}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#4a90e2", textDecoration: "underline" }}
          >
            <p>
              Transaction Details{" "}

              <IoChevronForward />
            </p>
          </a>
        </div>
        <button onClick={() => { setShowTransactionSucess(false), setTransactionHash("") }} className="buy-more">BUY MORE TOKENS</button>
      </Modal.Body>
    </Modal>
  );
};

export default TransactionSucessModal;
